"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _api = _interopRequireDefault(require("../../redux/api"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class SecureImage extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      source: ''
    };
  }

  componentDidMount() {
    const {
      url,
      accessToken
    } = this.props;
    this.getBase64(url, accessToken);
  }

  getBase64(url, accessToken) {
    return _api.default.get(url, {
      responseType: 'arraybuffer',
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }).then(response => {
      const prefix = 'data:image/jpg;base64,';
      const base64 = Buffer.from(response.data, 'binary').toString('base64');
      this.setState({
        source: prefix + base64
      });
    });
  }

  render() {
    const {
      source
    } = this.state;
    const {
      alt
    } = this.props;

    if (!source || source.length === 0) {
      return /*#__PURE__*/_react.default.createElement("div", null, "No image found for the following url:", this.props.url);
    }

    return /*#__PURE__*/_react.default.createElement("img", {
      style: {
        width: 'inherit',
        height: 'inherit'
      },
      alt: alt,
      src: source
    });
  }

}

const mapStateToProps = state => {
  return {
    accessToken: state.oidc.user ? state.oidc.user.access_token : ''
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, null)(SecureImage);

exports.default = _default;